import { gql, useMutation } from '@apollo/client';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';
// import * as Dbx from './dbx';

interface TData {
  scheduleSoftwareUpdate?: {
    id: string;
  }[];
}

interface TVariables {
  input: {
    update_url_ids: number[];
    location_ids: string[];
  };
}


interface Args {
  locations: string[];
  schedules: {
    id: string;
    updateAt: Date;
  }[];
}


const MUTATION = gql`
mutation UpgradeSoftwares($input: MultipleUpgradeInput!) {
  upgradeSoftwares(input: $input) {
    encoders {
      signal_sent
      location_id
    }
  }
}
`;

export const useUpdateDevicesNow = (): [
  (args: Args) => Promise<{ id: string }[] | undefined>,
  MutationResult<{ id: string }[], 'id'>
] => {
  const [mutate, { data, loading, error, called }] = useMutation<TData, TVariables>(MUTATION);

  return [
    useCallback(async (args: Args) => {
      let ids_: { id: string }[] | undefined;

      try {
        const variables = {
          input: {
            location_ids: args.locations,
            update_url_ids: args.schedules.map(i => Number(i.id))
          }
        };

        if (!variables.input.location_ids.length || !variables.input.update_url_ids.length) {
          return undefined;
        }

        const response = await mutate({ variables });

        ids_ = response.data?.scheduleSoftwareUpdate?.map(({ id }) => ({ id }))
          .filter((v): v is { id: string } => !!v.id);
      } catch {
        //
      }

      return ids_;
    }, [mutate]),
    {
      called,
      loading,
      id: data?.scheduleSoftwareUpdate
        ?.map(({ id }) => ({ id }))
        .filter((v): v is { id: string } => !!v.id),
      error
    }
  ];
};
